module.exports = __webpack_public_path__ + "static/img/yytx30.27db8a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx30.png
// module id = 898
// module chunks = 0